import React, { Component, createRef } from 'react'
import { Button, TableRow, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'

import { EditableTextField } from '../common/EditableComponents'
import PaymentModal from '../Modal/PaymentModal'

export default class PaymentHistoryItem extends Component {
  rightAlign = {
    textAlign: 'right',
  }

  paymentModal = createRef()

  onChange = onChangeEditHOF(this.props.onChange)

  openPaymentModalModal = () => {
    this.paymentModal.current.handleClickOpen()
  }

  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onClick = () => {
    window.open('www.google.com.pe', '_blank')
  }

  centerAlign = {
    textAlign: 'center',
  }

  render() {
    const { data = {}, payment } = this.props
    const { invoice } = payment

    return (
      <TableRow>
        <TableCell className="cell-wrap-word padding-small">
          <EditableTextField value={data.period} valueToRender={data.period} editMode={false} />
        </TableCell>
        <TableCell className="cell-wrap-word padding-small">
          <EditableTextField
            value={data.description}
            valueToRender={data.description}
            editMode={false}
          />
        </TableCell>
        <TableCell className="cell-wrap-word padding-small" style={this.centerAlign}>
          <EditableTextField value={data.amount} valueToRender={data.amount} editMode={false} />
        </TableCell>
        <TableCell className="cell-wrap-word padding-small" style={this.centerAlign}>
          <EditableTextField
            value={data.date ? data.date : '-'}
            valueToRender={data.date ? data.date : '-'}
            editMode={false}
          />
        </TableCell>
        <TableCell className="cell-wrap-word padding-small" style={this.centerAlign}>
          <EditableTextField value={data.status} valueToRender={data.status} editMode={false} />
        </TableCell>
        <TableCell className="cell-wrap-word padding-small" style={this.rightAlign}>
          {/* <Button variant="outlined" color="primary"  className="margin">
                        <a href={invoice.invoice_pdf} target="_blank">View</a>
                    </Button> */}
          <Button
            size="small"
            href={invoice.invoice_pdf}
            variant="outlined"
            color="primary"
            className="margin"
          >
            View
          </Button>
        </TableCell>
        <PaymentModal
          ref={this.paymentModal}
          addCard={this.addCard}
          onError={this.onError}
          payment={payment}
          rowData={data}
          size="lg"
        />
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Billing/PaymentHistoryItem.js